import {
  WARNING_LETTER_FETCHING,
  WARNING_LETTER_FAILED,
  WARNING_LETTER_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case WARNING_LETTER_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case WARNING_LETTER_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case WARNING_LETTER_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
